import React from 'react';
import {
  Box,
  Paper,
  Typography,
  IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const formatAlarm = (value) => {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return '-';
  return Math.max(0, Math.trunc(numeric)).toString();
};

const BuildingAlarmDetailPanel = ({
  building,
  alarms,
  onClose,
  style = {}
}) => {
  if (!building) return null;

  return (
    <Paper
      elevation={8}
      sx={{
        position: 'absolute',
        bottom: 24,
        right: { xs: 24, sm: 420 },
        width: { xs: '90%', sm: 380 },
        maxHeight: '70vh',
        overflow: 'hidden',
        zIndex: 110,
        backgroundColor: '#fff',
        borderRadius: 2,
        ...style
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          p: 2,
          borderBottom: '1px solid #e0e0e0',
          backgroundColor: '#8E2C2C'
        }}
      >
        <Typography variant="subtitle1" sx={{ color: '#fff', fontWeight: 600 }}>
          {building.name} Alarm Details
        </Typography>
        <IconButton size="small" onClick={onClose} sx={{ color: '#fff' }}>
          <CloseIcon />
        </IconButton>
      </Box>

      <Box sx={{ p: 2 }}>
        {[
          { label: 'Temperature Related', value: alarms?.tempAlarm },
          { label: 'Power Related', value: alarms?.powerAlarm },
          { label: 'Operations & Management', value: alarms?.oamAlarm },
          { label: 'Service Impacting', value: alarms?.serviceAlarm }
        ].map((item, idx) => (
          <Box
            key={idx}
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              py: 1.2,
              borderBottom: idx < 3 ? '1px solid #f0f0f0' : 'none'
            }}
          >
            <Typography sx={{ fontSize: '0.95rem', fontWeight: 500, color: '#333' }}>
              {item.label}
            </Typography>
            <Typography sx={{ fontSize: '1rem', fontWeight: 700, color: '#0A2240' }}>
              {formatAlarm(item.value)}
            </Typography>
          </Box>
        ))}
      </Box>
    </Paper>
  );
};

export default BuildingAlarmDetailPanel;
